import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from 'react';

export interface LoadingContextType {
  addOperationsInProgress: (key: string) => void;
  removeOperationsInProgress: (key: string) => void;
  operationsInProgress: Set<string>;
  updateKey: number | undefined;
  reload(): void;
}

export const LoadingContext = createContext<LoadingContextType>(null!);

export const LoadingProvider = (props: PropsWithChildren) => {
  const [updateKey, setUpdateKey] = useState<number | undefined>(undefined);

  const [loadingOperations, setLoadingOperations] = useState<Set<string>>(
    new Set(),
  );

  const addOperationsInProgress = (key: string) => {
    if (!loadingOperations.has(key)) {
      setLoadingOperations((prev) => {
        const current = new Set(prev);
        current.add(key);
        return current;
      });
    }
  };

  const removeOperationsInProgress = (key: string) => {
    setLoadingOperations((prev) => {
      if (prev.has(key)) {
        const current = new Set(prev);
        current.delete(key);
        return current;
      }

      return prev;
    });
    // }
  };

  const handleReload = useCallback(() => {
    setUpdateKey(Date.now());
  }, []);

  return (
    <LoadingContext.Provider
      value={{
        operationsInProgress: loadingOperations,
        addOperationsInProgress,
        removeOperationsInProgress,
        updateKey,
        reload: handleReload,
      }}
    >
      {props.children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => {
  return useContext(LoadingContext);
};
